<template>
  <Layout>

    <div slot="titlebarSecondRow">
      <SubNavBar :struct="tabStructure"></SubNavBar>
    </div>

    <div class="drcs">
      <section class="fieldset" style="margin-bottom: 15px;">
        <h3>{{ $t('papers.tabsDrc.listAdministrativeAsk') }}</h3>

        <table v-if="hasRecords" class="table">
          <thead>
          <tr>
            <th width="10%">{{ $t('papers.tabsDrc.tab.numAsk') }}</th>
            <th width="10%">{{ $t('papers.tabsDrc.tab.createdAt') }}</th>
            <th width="15%">{{ $t('papers.tabsDrc.tab.category') }}</th>
            <th>{{ $t('papers.tabsDrc.tab.title') }}</th>
            <th width="15%">{{ $t('papers.tabsDrc.tab.status') }}</th>
            <th width="10%">{{ $t('papers.tabsDrc.tab.lastAction') }}</th>
            <th width="5%">&nbsp;</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="drc in drcs">
            <td><strong>{{ formatId(drc) }}</strong></td>
            <td>{{ convertDate(drc.date, null,false) }}</td>
            <td>{{ drc.category !== null ? drc.category.libelle_categorie : 'Aucune' }}</td>
            <td>{{ drc.titre }}</td>
            <td>{{ drc.status.statut }}</td>
            <td><span :title="displaylastAction(drc,false)"> {{ displaylastAction(drc,true) }}</span></td>
            <td>
              <div @click="showDrcContent(drc)" class="dl-btn" title="Voir ma demande">
                <font-awesome-icon :icon="(isModalOpened && selectedDrc !== null && Number(selectedDrc.iddrc) === Number(drc.iddrc))  ? 'folder-open' : 'folder'"></font-awesome-icon>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
        <div v-else>
          <div class="no-result">{{ $t('papers.tabsDrc.notAskSaved') }}</div>
        </div>
      </section>
    </div>

  </Layout>
</template>

<script>
import Layout from '@l/BaseWithToolbar'
import SubNavBar from '@c/ui/SubNavBar'
import DrcViewer from "@c/drc/DrcViewer";
import {mapActions, mapGetters, mapMutations} from "vuex";
import moment from 'moment';



export default {
  name: 'Drc',
  beforeCreate: function () {

  },
  beforeDestroy: function () {

  },
  beforeMount: function () {
    this.$store.commit('UI/viewTitle',  window.V.$i18n.t('papers.tabsDrc.listAdministrativeAsk'))
  },
  beforeUpdate: function () {

  },
  components: {
    Layout,
    SubNavBar
  },
  computed: {
    ...mapGetters({
      drcs: 'Papers/drcs',
      isModalOpened : 'UI/showModal'
    }),
    tabStructure() {
      return [
        {name: window.V.$i18n.t("papers.tabsBar.society") , path: 'papersIndex', permission: 'admin-company-client'},
        {name: window.V.$i18n.t("papers.tabsBar.interlocutors") , path: 'interlocutors', permission: 'admin-contacts-client'},
        {name: window.V.$i18n.t("papers.tabsBar.bills") , path: 'bills', permission: 'admin-bills-client'},
        {name: window.V.$i18n.t("papers.tabsBar.administrativeAsk"), path: 'drc', permission: 'admin-bills-client', active: true}
      ];
    },
    hasRecords() {
      return Array.isArray(this.drcs) && this.drcs.length > 0;
    }
  },
  created: function () {

  },
  data() {
    return {
      selectedDrc:null
    }
  },
  destroyed: function () {

  },
  methods: {
    ...mapActions({
      getDrcs: 'Papers/getDrcs',
    }),
    ...mapMutations({
      setViewTitle: 'UI/viewTitle',
      showLoading: 'UI/showLoading',
      addError: 'Messages/addError',
      showModal: 'UI/showModal',
      setModalParams: 'UI/setModalParams'
    }),
    showDrcContent: function(drc) {
      this.selectedDrc = drc;
      this.setModalParams({
        title:  t("papers.tabsDrc.askInformations"),
        component : DrcViewer,
        width:'700px',
        height:'600px',
        props: {
          drc: drc
        }
      });
      this.showModal();
    },
    getLang: function () {
      if (navigator.languages !== undefined)
        return navigator.languages[0];
      else
        return navigator.language;
    },
    convertDate(date, heure, fromnow) {
      if (heure === null) {
        return (new Date(date)).toLocaleDateString();
      }
      moment.locale(this.getLang());
      if(fromnow)
      {
        return moment(date.substring(0, 10) + " " + heure).fromNow();
      }
      return (new Date(date.substring(0, 10) + " " + heure)).toLocaleString([], {year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit'});
    },
    formatId(record)
    {
      let id = record.iddrc+"";
      while (id.length<6)
      {
        id = "0"+id;
      }
      return id;
    },
    displaylastAction(record,showfrom) {
      switch (record.status.iddrc_statut) {
        case 1:
          return ""
        default:
          return this.convertDate(record.last_action, record.lastAction_h, showfrom);
      }
    }
  },
  mounted: function () {
    this.getDrcs().then(() => {
      this.showLoading(false);
    });
  },
  props: {},
  updated: function () {

  },
  watch: {
    isModalOpened(newVal, oldVal) {
      if(newVal === false)
      {
        this.selectedDrc = null;
        this.setModalParams({
          title: '',
          component : null,
          props: {
            drc: null
          }
        });
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/papers/Drc.vue